import { BfiCustomStore } from '@apply/ui';
import { PrincipalEntityLinks } from '../../../common/BorrowerComponents';
import { Item } from 'devextreme-react/tab-panel';

interface ILinkedEntitiesTabParameters {
    title: string;
    selectedTabIndex: number;
    principalId: number;
    entityId: number;
    linkStore: BfiCustomStore;
}

export const LinkedEntitiesTab: React.FC<ILinkedEntitiesTabParameters> = ({
    title,
    selectedTabIndex,
    principalId,
    entityId,
    linkStore,
}) => {
    return (
        <Item title={title}>
            <div
                style={{
                    width: '100%',
                    minHeight: '700px',
                }}
            >
                <PrincipalEntityLinks
                    principalId={selectedTabIndex === 1 ? principalId : null}
                    excludeEntityId={entityId}
                    parentId='editPrincipalModal'
                    gridStore={linkStore}
                />
            </div>
        </Item>
    );
};
